module.exports = __webpack_public_path__ + "img/CZ14893649.c2b49a74.png";